// extracted by mini-css-extract-plugin
export default {"privacyPolicyContainer":"PrivacyPolicy_privacyPolicyContainer__u6VW3","closeCart":"PrivacyPolicy_closeCart__veTsQ","privacyPolicy":"PrivacyPolicy_privacyPolicy__vOC5C"};